module.exports = "/_next/static/images/cosmopolitan-20706f6e24b343d359b8dcb40cd6fc2a.png";